import { useEffect, useState } from "react";
import { fetchClubs } from "./api";

export const useHasManagedClubs = (
  enabled = true,
  refreshKey = "",
): { hasManagedClubs: boolean; loading: boolean } => {
  const [hasManagedClubs, setHasManagedClubs] = useState(false);
  const [loading, setLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      setHasManagedClubs(false);
      setLoading(false);
      return;
    }

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const clubs = await fetchClubs();
        if (!cancelled) {
          setHasManagedClubs(clubs.length > 0);
        }
      } catch {
        if (!cancelled) {
          setHasManagedClubs(false);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [enabled, refreshKey]);

  return { hasManagedClubs, loading };
};
